import { assignInlineVars } from '@vanilla-extract/dynamic';
import { cx } from 'emotion';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdaptiveText from '@ezugi/primitives/src/AdaptiveText';
import { desktopAdaptiveText } from '@ezugi/primitives/src/AdaptiveText/style';
import { Button } from '@ezugi/ui/components';
import { buttonContentColor } from '@ezugi/ui/components/Button/Button.css';
import { theme } from '@ezugi/ui/theme.css';
import { DeviceInfo } from '@ezugi/utils';

import { useIntl } from '../../../hooks/useIntl';
import { betActions } from '../../../store/actions';
import {
  canPlaceBetsSelector,
  noBetHistorySelector,
} from '../../../store/selectors';
import { betToolbarButtonBase, betToolbarButtonMobile } from './Button.css';
import UndoIcon from './icons/undo';

const intlSpec = {
  keys: {
    undo: 'games_ui.undo_bet',
  },
};

const UndoButton = ({ className, hasLabel, disabled }: {
  disabled?: boolean;
  className?: string, hasLabel?: boolean }) => {
  const canPlaceBets = useSelector(canPlaceBetsSelector);
  const noBetHistory = useSelector(noBetHistorySelector);

  const locales = useIntl(intlSpec);
  const dispatch = useDispatch();

  const isDisabled = disabled ?? (!canPlaceBets || noBetHistory);

  const undo = useCallback(
    () => !isDisabled && dispatch(betActions.history.pop()),
    [ dispatch, isDisabled ]
  );

  const showLabel = hasLabel ?? !DeviceInfo.isHandheld;

  return (
    <Button
      data-testid="bet-toolbar-undo-button"
      data-disabled={isDisabled}
      style={{ ...assignInlineVars({
        [buttonContentColor]: theme.palette.foreground,
      }) }}
      className={cx(
        betToolbarButtonBase,
        {
          [betToolbarButtonMobile]: DeviceInfo.isHandheld,
        },
        className
      )}
      icon={UndoIcon}
      onClick={undo}
      disabled={isDisabled}
    >
      {showLabel && (
        <AdaptiveText
          className={desktopAdaptiveText}
        >
          {locales.undo}
        </AdaptiveText>
      )}
    </Button>
  );
};
export default memo(UndoButton);
